import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Card, CardContent, MuiTitle } from 'src/ui/mui-ui-kit';;
import { toast } from 'react-toastify';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-calculate';
import dayjs from 'dayjs-ext';
import { find, get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import arrayMutators from 'final-form-arrays';
import {
  InnerLoader,
  UiToastAdapter,
  clearPhoneNumber,
  reduceServerErrors,
  ConfirmDeletionModal,
  setBreadcrumbs,
  maskPhone,
  maskSsn,
} from 'src/ui';
import { getUser } from 'src/user';
import { getToken } from 'src/auth';
import {
  getAccount,
  fetchAccount,
  updateAccountPerson,
  updateAccountPersonBadge,
  setAccountPersonBadgeImages,
  addAccountPersonBadge,
  deleteAccountPersonBadge,
  setAccountPersonLicenseImages,
  fetchFormData,
  getFormData,
} from 'src/account';
import { DEFAULT_DATE_FORMAT } from 'src/ui/const';
import { usStates, militaryOptions } from 'src/core';
import {
  PersonProfileForm,
  BadgeModal,
  InsurancePersonProfileForm,
} from '../components';
import {
  ADDRESS_PREFIX_PRIMARY,
  ADDRESS_PREFIX_MAILING,
  COVERAGE_TYPE,
  RELATIONSHIP_TYPE,
  GENDER_CHOICES,
} from '../const';

// TODO: get from server
const citizenshipOptions = [
  {
    label: 'United States',
    value: 'US',
  },
];

const formCalculator = createDecorator(
  ...[ADDRESS_PREFIX_PRIMARY, ADDRESS_PREFIX_MAILING].map(prefix => ({
    field: `${prefix}AutocompleteAddress`,
    updates: {
      [`${prefix}Address`]: value => get(value, 'address'),
      [`${prefix}City`]: value => get(value, 'city'),
      [`${prefix}State`]: value =>
        find(usStates, { value: get(value, 'state') }),
      [`${prefix}Zipcode`]: value => get(value, 'zipCode'),
    },
  }))
);

class PersonEditPage extends Component {
  state = {
    loading: true,
    editingBadge: null,
    addingBadge: false,
    deletingBadge: null,
    initialValues: null,
  };

  async componentDidMount() {
    const { token } = this.props;

    if (!token.isEmpty()) {
      await this.loadData();
    }
  }

  get showBadges() {
    const { account, formData } = this.props;
    const { industries } = formData;

    if (industries && account.industries) {
      const accountIndustries = account.industries.map(industry =>
        find(industries, { id: industry })
      );

      // accountIndustries: accountIndustries = accountIndustries.filter(element => element !== undefined)
      // if (accountIndustries !== undefined && accountIndustries.length != 0){
      return accountIndustries
        .filter(element => element !== undefined)
        .some(({ name }) => name === 'MRB');
    }
    return false;
  }

  onEditBadge = badge => {
    const {
      account: { locations },
    } = this.props;

    this.setState({
      editingBadge: {
        ...badge,
        badgeDateExpired: badge.badgeDateExpired
          ? dayjs(badge.badgeDateExpired, {
              format: DEFAULT_DATE_FORMAT,
            })
              .utc()
              .toDate()
          : null,
        locationId: find(locations, { id: badge.locationId }),
      },
      addingBadge: false,
    });
  };

  onAddBadge = () => {
    this.setState({ addingBadge: true, editingBadge: null });
  };

  async setBadgeImages(badgeId, front, back) {
    if (typeof front !== 'string' || typeof back !== 'string') {
      const { setAccountPersonBadgeImages, user, match } = this.props;
      const id = +match.params.id;

      const badgeImages = {
        accountId: user.accountId,
        personId: id,
        badgeId,
        imageFront: typeof front === 'string' ? null : front,
        imageBack: typeof back === 'string' ? null : back,
      };

      await setAccountPersonBadgeImages(badgeImages);

      const { account: finishedAccount } = this.props;

      if (finishedAccount.isError()) {
        return reduceServerErrors(finishedAccount);
      }
    }
    this.cancelBadgeModal();
    toast(UiToastAdapter('Badge saved successfully!', 'success'));
    return undefined;
  }

  async setLicenseImages(personId, imageFront, imageBack) {
    const { user, setAccountPersonLicenseImages } = this.props;
    await setAccountPersonLicenseImages({
      accountId: user.accountId,
      personId,
      imageFront:
        imageFront !== null && typeof imageFront === 'string'
          ? null
          : imageFront,
      imageBack:
        imageBack !== null && typeof imageBack === 'string' ? null : imageBack,
    });
    this.setState({ loading: false });
    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    toast(UiToastAdapter('License images uploaded successfully!', 'success'));
    return undefined;
  }

  // handleInsuranceSubmit = async values => {
  //   this.setState({ loading: true });
  //   const { user, match } = this.props;
  //   const id = +match.params.id;
  //   const person = {
  //     ...values,
  //     dob: values.dob ? dayjs(values.dob).format(DEFAULT_DATE_FORMAT) : null,
  //     personId: id,
  //     accountId: user.accountId,
  //     financialInstitutionId: user.financialInstitutionId,
  //     primaryNumber: clearPhoneNumber(values.primaryNumber),
  //   };
  //   this.setState({ loading: false });
  // };

  // eslint-disable-next-line consistent-return
  handleSubmit = async values => {
    const { updateAccountPerson, user, match } = this.props;
    const { initialValues } = this.state;
    const id = +match.params.id;
    this.setState({ loading: true });
    
    const { licenseImageFront, licenseImageBack, ...restValues } = values;
    
    const person = {
      ...restValues,
      accountId: user.accountId,
      financialInstitutionId: user.financialInstitutionId,
      personId: id,
      primaryNumber: clearPhoneNumber(restValues.primaryNumber),
      otherNumber: clearPhoneNumber(restValues.otherNumber),
      citizenship: get(restValues.citizenship, 'value', null),
      dob: restValues.dob ? dayjs(restValues.dob).format(DEFAULT_DATE_FORMAT) : null,
      licenseExpirationDate: restValues.licenseExpirationDate
        ? dayjs(restValues.licenseExpirationDate).format(DEFAULT_DATE_FORMAT)
        : null,
      licenseIssuedDate: restValues.licenseIssuedDate
        ? dayjs(restValues.licenseIssuedDate).format(DEFAULT_DATE_FORMAT)
        : null,
      licenseIssuingState: get(restValues.licenseIssuingState, 'value', null),
      licenseTypeId: get(restValues.licenseTypeId, 'value', null),
      primaryState: get(restValues.primaryState, 'value', null),
      mailingState: get(restValues.mailingState, 'value', null),
      military: get(restValues.military, 'value', null),
      socialSecurity:
        (restValues.socialSecurity || '').toString().replace(/[^\d]/g, '') || null,
      coverage: get(restValues.coverage, 'value', null),
      insuranceGroupName: restValues.insuranceGroupName,
      gender: get(restValues.gender, 'value', null),
      familyMembers: [],
    };
    
    // Handle license image deletion
    // If image was cleared (null, undefined, or empty string) and was previously set, send null to delete it
    if (
      (licenseImageFront == null || licenseImageFront === '') &&
      initialValues?.licenseImageFront != null &&
      initialValues?.licenseImageFront !== ''
    ) {
      person.user_license_image_front = null;
    }
    
    if (
      (licenseImageBack == null || licenseImageBack === '') &&
      initialValues?.licenseImageBack != null &&
      initialValues?.licenseImageBack !== ''
    ) {
      person.user_license_image_back = null;
    }
    
    if (restValues.sameAsPrimary) {
      person.mailingAddress = person.primaryAddress;
      person.mailingAddress2 = person.primaryAddress2;
      person.mailingCity = person.primaryCity;
      person.mailingState = person.primaryState;
      person.mailingZipcode = person.primaryZipcode;
    }
    if (
      user.financialInstitutionForInsurance &&
      restValues.familyMembers.length > 0
    ) {
      person.familyMembers = restValues.familyMembers.map(member => ({
        insurance_family_member_id: member.id,
        insurance_family_member_first_name: member.firstName,
        insurance_family_member_last_name: member.lastName,
        insurance_family_member_gender: get(member.gender, 'value', null),
        insurance_family_member_relationship: get(
          member.relationship,
          'value',
          null
        ),
        insurance_family_member_dob: dayjs(member.dob).format(
          DEFAULT_DATE_FORMAT
        ),
      }));
    }
    await updateAccountPerson(person);
    const { account } = this.props;
    if (account.isError()) {
      this.setState({ loading: false });
      return reduceServerErrors(account);
    }
    if (
      (licenseImageBack !== null && typeof licenseImageBack !== 'string') ||
      (licenseImageFront !== null && typeof licenseImageFront !== 'string')
    ) {
      toast(
        UiToastAdapter(
          'Person updated, sending identification images...',
          'info'
        )
      );
      return this.setLicenseImages(id, licenseImageFront, licenseImageBack);
    }
    toast(UiToastAdapter('Person updated successfully!', 'success'));
    this.setState({
      loading: false,
      initialValues: values,
    });
  };

  cancelBadgeModal = () => {
    this.setState({ addingBadge: false, editingBadge: null });
  };

  submitBadge = async values => {
    const { addingBadge } = this.state;
    let result;
    if (addingBadge) {
      result = await this.addNewBadge(values);
    } else {
      result = await this.editBadge(values);
    }
    return result;
  };

  onDeleteBadge = badge => {
    this.setState({ deletingBadge: badge });
  };

  onCancelDeleteBadge = () => {
    this.setState({ deletingBadge: null });
  };

  onConfirmDeleteBadge = async () => {
    const { deleteAccountPersonBadge, user, match } = this.props;
    const { deletingBadge } = this.state;
    const id = +match.params.id;
    this.setState({ loading: true, deletingBadge: null });
    await deleteAccountPersonBadge({
      accountId: user.accountId,
      personId: id,
      badgeId: deletingBadge.id,
    });

    this.setState({ loading: false });
  };

  async addNewBadge(values) {
    const { addAccountPersonBadge, user, match } = this.props;
    const id = +match.params.id;
    const { badgeImageFront, badgeImageBack } = values;
    const badge = {
      ...values,
      accountId: user.accountId,
      personId: id,
      locationId: get(values.locationId, 'id', null),
      badgeDateExpired: values.badgeDateExpired
        ? dayjs(values.badgeDateExpired).format(DEFAULT_DATE_FORMAT)
        : null,
    };
    const result = await addAccountPersonBadge(badge);
    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    const badgeId = result.payload.id;
    return this.setBadgeImages(badgeId, badgeImageFront, badgeImageBack);
  }

  async editBadge(values) {
    const { updateAccountPersonBadge, user, match } = this.props;
    const { editingBadge } = this.state;
    const id = +match.params.id;
    const { badgeImageFront, badgeImageBack } = values;
    const badge = {
      ...values,
      personId: id,
      badgeId: editingBadge.id,
      accountId: user.accountId,
      badgeDateExpired: values.badgeDateExpired
        ? dayjs(values.badgeDateExpired).format(DEFAULT_DATE_FORMAT)
        : null,
      locationId: get(values.locationId, 'id', null),
    };
    await updateAccountPersonBadge(badge);
    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    return this.setBadgeImages(badge.id, badgeImageFront, badgeImageBack);
  }

  async loadData() {
    const {
      user,
      fetchAccount,
      match,
      setBreadcrumbs,
      fetchFormData,
    } = this.props;
    this.setState({ loading: true });
    if (user.accountId) {
      await fetchAccount(user.accountId);
      const { account } = this.props;
      const insuranceGroupNames = account.insuranceGroupNames
        ? account.insuranceGroupNames.map(({ name, id }) => ({
            label: name,
            value: id,
          }))
        : null;
      if (account.isError()) {
        toast(UiToastAdapter(account.errorMessage().detail, 'danger'));
      } else {
        await fetchFormData(
          user.financialInstitutionId || account.financialInstitutions[0].id,
          user.accountId
        );
        const person = find(account.people, { id: +match.params.id });
        const breadcrumbs = [];
        if (user.isMerchantAdmin) {
          breadcrumbs.push({ label: 'People', href: '/people' });
        }
        breadcrumbs.push({
          label: `Edit ${person.firstName} ${person.lastName}`,
          href: `/people/edit/${match.params.id}`,
        });
        setBreadcrumbs(breadcrumbs);
        const { formData } = this.props;
        const { personLicenseTypes } = formData;
        const licenseType = find(personLicenseTypes, {
          id: person.licenseTypeId,
        });
        let licenseTypeOption = null;
        if (licenseType) {
          licenseTypeOption = {
            value: licenseType.id,
            label: licenseType.name,
          };
        }
        this.setState({
          initialValues: {
            ...person,
            citizenship:
              find(citizenshipOptions, {
                value: person.citizenship,
              }) || citizenshipOptions[0],
            dob:
              person.dob &&
              dayjs(person.dob)
                .utc()
                .toDate(),
            licenseExpirationDate:
              person.licenseExpirationDate &&
              dayjs(person.licenseExpirationDate)
                .utc()
                .toDate(),
            licenseIssuedDate:
              person.licenseIssuedDate &&
              dayjs(person.licenseIssuedDate)
                .utc()
                .toDate(),
            licenseIssuingState: find(usStates, {
              value: person.licenseIssuingState,
            }),
            licenseTypeId: licenseTypeOption,
            mailingState: find(usStates, { value: person.mailingState }),
            primaryState: find(usStates, { value: person.primaryState }),
            military: find(militaryOptions, { value: person.military }),
            primaryNumber:
              person.primaryNumber && maskPhone(person.primaryNumber),
            otherNumber: person.otherNumber && maskPhone(person.otherNumber),
            socialSecurity: maskSsn(person.socialSecurity),
            sameAsPrimary: false,
            coverage: find(COVERAGE_TYPE, {
              value: person.insuranceInformation.coverage,
            }),
            zipcode: person.primaryZipcode,
            gender: find(GENDER_CHOICES, { value: person.gender }),
            insuranceInformationMarkedComplete:
              person.insuranceInformation.insuranceInformationMarkedComplete,
            insuranceGroupName: find(insuranceGroupNames, {
              label: person.insuranceInformation.groupName,
            }),
            familyMembers: person.insuranceInformation.familyMembers
              ? person.insuranceInformation.familyMembers.map(member => ({
                  ...member,
                  relationship: find(RELATIONSHIP_TYPE, {
                    value: member.relationship,
                  }),
                  gender: find(GENDER_CHOICES, { value: member.gender }),
                  dob:
                    member.dob &&
                    dayjs(member.dob)
                      .utc()
                      .toDate(),
                }))
              : [],
            // familyMembers: person.insuranceInformation.familyMembers
          },
        });
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { isExpanded, user, account, formData } = this.props;
    const {
      loading,
      editingBadge,
      addingBadge,
      initialValues,
      deletingBadge,
    } = this.state;
    const { personLicenseTypes } = formData;
    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          Person Profile
          {(user.isMerchantAdmin || user.isBankAdmin) && (
            <NavLink
              className="close-page button is-small is-text is-pulled-right"
              to="/people"
            >
              <span className="icon has-text-danger">
                <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
              </span>
            </NavLink>
          )}
        </MuiTitle>
        <Form
          onSubmit={this.handleSubmit}
          mutators={{
            ...arrayMutators,
          }}
          initialValues={initialValues}
          decorators={[formCalculator]}
          subscription={{
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtySinceLastSubmit: true,
            values: {
              sameAsPrimary: true,
              licenseNumber: true,
              coverOptions: COVERAGE_TYPE[0],
            },
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
            values,
            form: {
              mutators: { push, pop },
            },
          }) => (
            <Card className="person-edit-page">
              <CardContent>
                {user.financialInstitutionForInsurance ? (
                  <InsurancePersonProfileForm
                    onSubmit={handleSubmit}
                    submitting={submitting}
                    hasValidationErrors={hasValidationErrors}
                    isDirty={dirtySinceLastSubmit || dirty}
                    isExpanded={isExpanded}
                    // militaryOptions={militaryOptions}
                    coverageOptions={COVERAGE_TYPE}
                    relationshipOptions={RELATIONSHIP_TYPE}
                    genderOptions={GENDER_CHOICES}
                    insuranceGroupNames={
                      account.insuranceGroupNames
                        ? account.insuranceGroupNames.map(({ name, id }) => ({
                            label: name,
                            value: id,
                          }))
                        : null
                    }
                    citizenshipOptions={citizenshipOptions}
                    statesOptions={usStates}
                    values={values}
                    account={account}
                    isAdmin={user.isMerchantAdmin || user.isBankAdmin}
                    push={push}
                    pop={pop}
                    onEditBadge={this.onEditBadge}
                    onAddBadge={this.onAddBadge}
                    onDeleteBadge={this.onDeleteBadge}
                    user={user}
                    showBadges={this.showBadges}
                    licenseTypes={personLicenseTypes}
                  />
                ) : (
                  <PersonProfileForm
                    onSubmit={handleSubmit}
                    submitting={submitting}
                    hasValidationErrors={hasValidationErrors}
                    isDirty={dirtySinceLastSubmit || dirty}
                    isExpanded={isExpanded}
                    militaryOptions={militaryOptions}
                    citizenshipOptions={citizenshipOptions}
                    statesOptions={usStates}
                    values={values}
                    account={account}
                    onEditBadge={this.onEditBadge}
                    onAddBadge={this.onAddBadge}
                    onDeleteBadge={this.onDeleteBadge}
                    user={user}
                    showBadges={this.showBadges}
                    licenseTypes={personLicenseTypes}
                  />
                )}
              </CardContent>
              <InnerLoader visible={loading || submitting} />
            </Card>
          )}
        />
        <BadgeModal
          badge={editingBadge}
          isActive={addingBadge || !!editingBadge}
          onFinish={this.submitBadge}
          onCancel={this.cancelBadgeModal}
          locations={account.locations || []}
        />
        <ConfirmDeletionModal
          isActive={!!deletingBadge}
          onClickCancel={this.onCancelDeleteBadge}
          onClickConfirm={this.onConfirmDeleteBadge}
          title={`Badge number ${(deletingBadge || {}).badgeNumber}`}
        />
      </>
    );
  }
}

PersonEditPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  match: propTypes.object.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  updateAccountPerson: propTypes.func.isRequired,
  updateAccountPersonBadge: propTypes.func.isRequired,
  setAccountPersonBadgeImages: propTypes.func.isRequired,
  addAccountPersonBadge: propTypes.func.isRequired,
  deleteAccountPersonBadge: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  setAccountPersonLicenseImages: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
    formData: getFormData(state),
  };
}

const connectedPersonEditPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchFormData,
  fetchAccount,
  updateAccountPerson,
  updateAccountPersonBadge,
  setAccountPersonBadgeImages,
  addAccountPersonBadge,
  deleteAccountPersonBadge,
  setAccountPersonLicenseImages,
})(PersonEditPage);

export { connectedPersonEditPage as PersonEditPage };
